import Axios from 'axios';
import axios from "./axios";
export const getLiterals = (page, search, count) => axios.get('/literals/v1', {
  params: {
    page,
    search
  },
  headers: {
    count
  }
});
export const updateLiterals = data => axios.put('/literals/v1', data, {
  count: data.length
}, {
  timeout: 60 * 1000 * 10 // 10 min
});
export const getLiteralsLogin = lang => Axios.get('https://fmliterals.forcemanager.net/login/v1/101/' + lang + '.json');